// L'agenda d'un membre sans le module Santé : la même vue que les portails, servie par /api/agenda.

import { useEffect, useState } from 'react';

import type { Actions } from '../App';
import { type Agenda as DonneesAgenda, NonConnecte, api } from '../lib/api';
import { VuePortails } from './Portails';

export function Agenda({ actions }: { actions: Actions }) {
  const [agenda, setAgenda] = useState<DonneesAgenda | null>(null);

  useEffect(() => {
    api.agenda().then(setAgenda).catch((e: Error) => {
      if (e instanceof NonConnecte) window.location.hash = '#/connexion';
      else actions.toast({ texte: e.message, erreur: true });
    });
  }, [actions]);

  if (!agenda) return <main className="ecran centre"><p className="message muted">Chargement…</p></main>;
  return <VuePortails date={agenda.date} ouverts={agenda.ouverts} jours={agenda.jours} sante={false} />;
}
